export default function NativeBridgeUpgradePage() {
  return (
    <main className="min-h-screen bg-white px-6 pt-[calc(env(safe-area-inset-top,0px)+32px)] pb-[calc(env(safe-area-inset-bottom,0px)+32px)] flex items-center justify-center">
      <section className="w-full max-w-[320px] text-center">
        <h1 className="text-[#1C1917] text-[20px] leading-7 font-semibold font-['DM_Sans']">
          客户端版本太老
        </h1>
        <p className="mt-3 text-[#57534E] text-[15px] leading-6 font-normal font-['DM_Sans']">
          请升级后继续使用。
        </p>
      </section>
    </main>
  );
}
